import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import map from 'lodash/map';
import Label from 'zignal-landscape/lib/Label';
import ToggleSwitch from 'zignal-landscape/lib/ToggleSwitch';
import Button from 'zignal-landscape/lib/Button';
import * as actions from './DataSources.ducks';
import styles from './themes/light.css';

import Heading from 'zignal-landscape/lib/Heading';

const mapStateToProps = (
  (state) => (state.DataSources)
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class DataSources extends Component {
  constructor(props) {
    super(props);
    this.props.setData(pick(this.props.account.attributes, map(props.displayOptions, 'displayValue')));
  }

  render() {
    const { displayOptions, setData, saveAccount } = this.props;
    return (
      <div className={styles.DataSources}>
        <div className={styles.dataSourcesRow}>
          {displayOptions.map(({displayLabel, displayValue, options}) =>
            (<div key={displayValue}>
              <Heading>{displayLabel}</Heading>
              {
                options.map(({label, value}) => {
                  const storeObj = this.props[displayValue];
                  let enabled = storeObj[value];
                  if (value === 'twitter') {
                    enabled = storeObj[value] === undefined ? true : storeObj[value];
                  }
                  return (
                    <div key={value} className={styles.switchRow}>
                      <Label name={`${value}_switch`}>Access to {label}</Label>
                      <ToggleSwitch
                        id={`${value}_switch`}
                        enabled={enabled}
                        onChange={(e) => setData({[displayValue]: {[value]: e.target.checked}})}
                      />
                    </div>
                  );
                })
              }
            </div>)
          )}
        </div>
        <div className={styles.dataSourceSave}>
          <Button id="save_button" buttonStyle="positive" onClick={() => saveAccount(this.props)}>
            Save
          </Button>
        </div>
      </div>
    );
  }
}

DataSources.propTypes = {
  styles: PropTypes.object,
  setData: PropTypes.func,
  saveAccount: PropTypes.func,
  // passed as props
  displayOptions: PropTypes.array,
  account: PropTypes.object,
};

DataSources.defaultProps = {
  displayOptions: []
};

export default connect(mapStateToProps, actions, mergeProps)(DataSources);
